import { render, staticRenderFns } from "./EarlyProductItem.vue?vue&type=template&id=4ea438e2&scoped=true"
import script from "./EarlyProductItem.vue?vue&type=script&lang=js"
export * from "./EarlyProductItem.vue?vue&type=script&lang=js"
import style0 from "./EarlyProductItem.vue?vue&type=style&index=0&id=4ea438e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea438e2",
  null
  
)

export default component.exports